import * as yup from '@if/core/yup'
import { Constants } from '@src/types'

export const buildEditSinAndLoanAmountSchema = (maxLoanAmount: number) => {
  return yup.object({
    id: yup.string().default(''),
    needsApplicantSin: yup.bool(),
    needsCoapplicantSin: yup.bool(),
    applicantSin: yup
      .string()
      .nullable()
      .when('needsApplicantSin', {
        is: true,
        then: (schema) => schema.required().validSIN(),
      }),
    coapplicantSin: yup
      .string()
      .nullable()
      .when('needsCoapplicantSin', {
        is: true,
        then: (schema) => schema.required().validSIN(),
      }),
    requestedLoanAmount: yup.double().required().default(0).min(Constants.MinLoanAmount).max(maxLoanAmount),
  })
}

export type EditSinAndLoanAmount = yup.InferType<ReturnType<typeof buildEditSinAndLoanAmountSchema>>
